document.addEventListener('selectoptionschanged', event => {
    const select = event.selectContainer.querySelector('select[name="itemSort"]');
    const row    = select?.closest('[data-item-sort]');

    if (!row) {
        return;
    }

    const directionalSorts = row.dataset.directionalSorts.split(',');

    row.querySelector('[data-item-sort-direction]').toggleAttribute('hidden', !directionalSorts.includes(select.value));
});
